import { FormInputType, SettingsFormData, SettingsFormInputData } from '../../components';
import { ConfigurationType, LmgmtKey } from '../../../../apps/keba-wallbox-app/src/plugins/keba-wallbox-plugin';
import { Validators } from '@angular/forms';
import { SettingsValidators } from '../../utils/SettingsValidators';
import { SettingsUnitsConverter } from '../../utils';

export const torSettingsDefinition: SettingsFormInputData[] = [
  {
    key: LmgmtKey.TOR_ENABLED,
    type: FormInputType.SELECT,
    configurationType: ConfigurationType.LMGMT,
    description: 'kw.settings.tor.enabled.description',
    title: 'kw.settings.tor.enabled.title',
    selectOptions: [
      { key: 'false', text: 'NONE' },
      { key: 'true', text: 'TOR Austria' },
    ],
    accessibilityId: 'tor-enabled',
    defaultValue: 'false',
    onChangeSetValues: {
      ifValue: 'true',
      setValues: [
        {
          configurationType: ConfigurationType.LMGMT,
          configs: [
            { key: LmgmtKey.ENABLE_ASYM_NETWORK, value: 'true', override: true },
            { key: LmgmtKey.NOMINAL_VOLTAGE, value: '230', override: true },
            { key: LmgmtKey.TOR_WAITING_TIME, value: '5', override: false },
            { key: LmgmtKey.TOR_UNDERVOLTAGE_LIMIT, value: '80', override: false },
            { key: LmgmtKey.TOR_UNDERVOLTAGE_OBSERVATION_PERIOD, value: '3', override: false },
          ],
        },
      ],
    },
    lockOnValueRead: {
      configurationType: ConfigurationType.LMGMT,
      key: LmgmtKey.TOR_ENABLED,
      value: 'true',
      toggleServiceKey: ['kw.common.connectionTypes.isNotBle', 'kw.common.productTypes.isNotP40'],
    },
    listenOnChanges: true,
    changeValueConfirmation: {
      condition: (oldValue: any, nextValue: any) => nextValue === true || nextValue === String(true),
      data: {
        title: 'kw.settings.tor.enable-tor-dialog.title',
        description: 'kw.settings.tor.enable-tor-dialog.description',
        confirmText: 'kw.settings.tor.enable-tor-dialog.confirm',
        cancelText: 'kw.settings.tor.enable-tor-dialog.decline',
        showConfirm: true,
        showCancel: true,
      },
    },
    readOnlyInfoText: 'kw.settings.tor.enabled.locked-info',
  },
  {
    key: LmgmtKey.TOR_WAITING_TIME,
    type: FormInputType.NUMBER,
    configurationType: ConfigurationType.LMGMT,
    description: 'kw.settings.tor.waiting-time.description',
    title: 'kw.settings.tor.waiting-time.title',
    accessibilityId: 'tor-waiting-time',
    defaultValue: 5,
    min: 0,
    max: 300,
    validators: [Validators.min(0), Validators.max(300), Validators.required],
    lockOnValueRead: {
      configurationType: ConfigurationType.LMGMT,
      key: LmgmtKey.TOR_ENABLED,
      value: 'true',
      toggleServiceKey: ['kw.common.connectionTypes.isNotBle', 'kw.common.productTypes.isNotP40'],
    },
    preventDecimal: true,
    showDependentOnOtherSetting: { [LmgmtKey.TOR_ENABLED]: 'true' },
    readOnlyInfoText: 'kw.settings.tor.locked-info',
  },
  {
    key: LmgmtKey.TOR_UNDERVOLTAGE_LIMIT,
    type: FormInputType.DECIMAL,
    configurationType: ConfigurationType.LMGMT,
    description: 'kw.settings.tor.undervoltage-limit.description',
    title: 'kw.settings.tor.undervoltage-limit.title',
    accessibilityId: 'tor-undervoltage-limit',
    defaultValue: 80,
    min: 70,
    max: 80,
    step: '0.1',
    validators: [Validators.min(70), Validators.max(80), Validators.required],
    lockOnValueRead: {
      configurationType: ConfigurationType.LMGMT,
      key: LmgmtKey.TOR_ENABLED,
      value: 'true',
      toggleServiceKey: ['kw.common.connectionTypes.isNotBle', 'kw.common.productTypes.isNotP40'],
    },
    showDependentOnOtherSetting: { [LmgmtKey.TOR_ENABLED]: 'true' },
    readOnlyInfoText: 'kw.settings.tor.locked-info',
    maxDecimals: 1,
  },
  {
    key: LmgmtKey.TOR_UNDERVOLTAGE_OBSERVATION_PERIOD,
    type: FormInputType.NUMBER,
    configurationType: ConfigurationType.LMGMT,
    description: 'kw.settings.tor.undervoltage-limit-observation-period.description',
    title: 'kw.settings.tor.undervoltage-limit-observation-period.title',
    accessibilityId: 'tor-undervoltage-limit-observation-period',
    defaultValue: 3,
    min: 3,
    max: 10,
    validators: [Validators.min(3), Validators.max(10), Validators.required],
    lockOnValueRead: {
      configurationType: ConfigurationType.LMGMT,
      key: LmgmtKey.TOR_ENABLED,
      value: 'true',
      toggleServiceKey: ['kw.common.connectionTypes.isNotBle', 'kw.common.productTypes.isNotP40'],
    },
    preventDecimal: true,
    showDependentOnOtherSetting: { [LmgmtKey.TOR_ENABLED]: 'true' },
    readOnlyInfoText: 'kw.settings.tor.locked-info',
  },
  {
    key: LmgmtKey.MAX_ASYM_PHASE_CURRENT,
    type: FormInputType.NUMBER,
    description: 'kwa.settings.installer-settings.max-asym-current.description',
    title: 'kwa.settings.installer-settings.max-asym-current.title',
    configurationType: ConfigurationType.LMGMT,
    max: 32,
    pattern: /^(0|[6-9]|\d{2,})$/,
    patternText: 'kwa.settings.installer-settings.max-asym-current.requirement.zero-or-min',
    // value needs to be <= than max HW current and between 0 and 32
    validators: [Validators.min(0), Validators.max(32), SettingsValidators.maxAsymPhaseCurrentValidator],
    convertToDisplayUnit: SettingsUnitsConverter.milliAmpereToAmpere,
    convertFromDisplayUnit: SettingsUnitsConverter.ampereToMilliAmpere,
    accessibilityId: 'installer-settings-max-asym-phase-current',
    readOnly: false,
    showDependentOnOtherSetting: { [LmgmtKey.TOR_ENABLED]: 'true' },
    toggleServiceKey: ['kw.common.productTypes.isP40', 'kw.common.env.isApp'],
  },
];
export const torFormDefinition: SettingsFormData[] = [
  {
    elements: [...torSettingsDefinition],
  },
];
